import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { StyledBranch } from './styled'
import CardPrototype from './CardPrototype'
import { useWindowSize } from 'hooks/useWindowSize'

const BranchItem = ({ currency, shop }) => {
	const {
		id,
		name,
		cashRegisters = [],
		statistics
	} = shop
	const [t] = useTranslation()
	const history = useHistory()
	const { width } = useWindowSize()

	const redirectToDetails = () => history.push(`/branch/${id}`)

	const cashRegistersCount = cashRegisters.length
	const allowedCashRegisters = cashRegisters.filter((el) => el.isAvailableInWebApp)
	const isShopIdIsAllowed = allowedCashRegisters.length > 0 || cashRegistersCount === 0
	const isTotalIconBig = width >= 1200 || (width <= 768 && width >= 576)

	const missingDataText = t('dashboard_section.information_is_missing')
	const noAccessText = 'no access'
	const missData = false

	const total = `${statistics.total?.toFixed(2) || '0.00'} ${currency}`
	const cashDifference = `${statistics.closingData?.cashDifference?.toFixed(2) || '0.00'} ${currency}`
	const totalPerBill = `${statistics?.totalPerBill?.toFixed(2) || '0.00'} ${currency}`
	const customerCount = statistics.customerCount || '0'
	const realHours = statistics.realHours || '00:00'
 	const totalPerRealTimeHours = `${statistics?.totalPerRealTimeHours?.toFixed(2) || '00.00'} ${currency}/${t('dashboard_section.hour_abbreviated')}`

 	const getDataOrText = data => {
 		if(!isShopIdIsAllowed) {
 			return noAccessText
 		}
 		if(missData) {
 			return missingDataText
 		}
 		return data
 	}

	return(
		<StyledBranch
			onClick={isShopIdIsAllowed && redirectToDetails}
			isNumberBig={isNumberBigHandler(cashRegisters.length)}
			isShopIdIsAllowed={isShopIdIsAllowed}
		>
			<CardPrototype
				t={t}
				name={name}
				cashRegistersCount={cashRegistersCount}
				allowedCashRegistersCount={allowedCashRegisters.length}
				isTotalIconBig={isTotalIconBig}
				total={getDataOrText(total)}
				cashDifference={getDataOrText(cashDifference)}
				avgBill={getDataOrText(totalPerBill)}
				customersCount={getDataOrText(customerCount)}
				realHours={getDataOrText(realHours)}
				totalPerRealTimeHours={getDataOrText(totalPerRealTimeHours)}
			/>
		</StyledBranch>
	)
}

export const isNumberBigHandler = (number) => {
	const lengthNumberString = number.toString().length
	return lengthNumberString > 1
}

const { string, number, shape, any } = PropTypes
BranchItem.propTypes = {
	currency: string.isRequired,
	shop: shape({
		id: string.isRequired,
		name: string.isRequired,
		cashRegisters: any,
		statistics: shape({
			total: number,
			closingData: shape({
				cashDifference: number
			}),
			totalPerBill: number,
			customerCount: number,
			realHours: string,
			totalPerRealTimeHours: number
		}).isRequired
	}).isRequired
}

export default BranchItem
